import { tokens } from '@cast/design-system';
import { clusterColors } from '@cast/features-cluster-ui';

const { data } = tokens.theme;

export const useDashboardFleetChartColors = () => {
  return {
    requested: clusterColors.requested,
    used: clusterColors.used,
    onDemand: data.blue300,
    spot: data.indigo800,
    fallback: data.yellow400,
  };
};
